'use client';

import type { CSSProperties } from 'react';

const widgetSurfaceCycle = [
  'var(--surface-base)',
  'var(--surface-soft)',
  'var(--surface-muted)',
  'var(--surface-alt)',
] as const;

export const widgetSectionPadding = { base: 34, md: 52 } as const;

export const widgetBadgeStyle: CSSProperties = {
  width: 'fit-content',
  border: '1px solid var(--surface-border)',
  background: 'var(--surface-soft)',
  color: 'var(--text-primary)',
  letterSpacing: '0.04em',
};

export const widgetTitleStyle: CSSProperties = {
  color: 'var(--text-primary)',
  fontWeight: 600,
  lineHeight: 1.35,
  letterSpacing: '-0.01em',
  fontSize: 'clamp(1.9rem, 3.5vw, 2.55rem)',
};

export const widgetSubtitleStyle: CSSProperties = {
  color: 'var(--text-secondary)',
  lineHeight: 1.72,
  maxWidth: 760,
};

export const widgetPrimaryButtonStyles = {
  root: {
    background: 'var(--brand-primary)',
    color: '#fff',
    fontWeight: 600,
    borderColor: 'transparent',
  },
};

export const widgetLinkStyle: CSSProperties = {
  color: 'var(--text-primary)',
  fontWeight: 600,
};

export const getWidgetSurface = (index: number) =>
  widgetSurfaceCycle[index % widgetSurfaceCycle.length];

export const getWidgetCardStyle = (
  index: number,
  options?: { emphasize?: boolean; minHeight?: number },
): CSSProperties => {
  const surface = getWidgetSurface(index);
  const emphasize = options?.emphasize === true;
  const emphasizedSurface = getWidgetSurface(index + 1);

  return {
    borderWidth: 1.5,
    borderStyle: 'solid',
    borderColor: 'var(--surface-border)',
    background: emphasize ? emphasizedSurface : surface,
    minHeight: options?.minHeight,
  };
};
